<script lang="ts">
    import { createDialog } from '@melt-ui/svelte';
    import { quintOut } from 'svelte/easing';
    import type { Writable } from 'svelte/store';
    import { scale } from 'svelte/transition';

    import cn from '$common/utils/cn';

    export let onClose: () => void | undefined = () => {};
    export let isOpen: Writable<boolean> | undefined;
    export let fullScreen: boolean = true;

    const {
        elements: { portalled, content },
        states: { open },
    } = createDialog({
        role: 'alertdialog',
        open: isOpen,
    });
</script>

<div {...$portalled} use:portalled>
    {#if $open}
        {#if !fullScreen}
            <div class="fixed inset-0 z-40 bg-black/50"></div>
        {/if}
        <div
            {...$content}
            use:content
            class={cn(
                'fixed z-50 overflow-y-scroll bg-white',
                fullScreen
                    ? 'inset-0 h-full w-full'
                    : 'left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform',
            )}
            transition:scale={{
                duration: 200,
                easing: quintOut,
            }}
        >
            {#if $$slots.header}
                <div
                    class="min-h-[76px] border-b border-solid border-border-quiet p-xl"
                >
                    <slot name="header" />
                </div>
            {/if}
            <slot />
        </div>
    {/if}
</div>

<!-- Override escape key event to trigger onClose callback -->
<svelte:window
    on:keydown={(event) => {
        if (event.key === 'Escape' && $open) {
            $open = false;
            onClose();
        }
    }}
/>
